var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.2568 2.50396c-.0969-.08362-.2147-.13923-.3408-.16085-.1261-.02161-.2557-.00841-.3749.03819l-15.83278 6.1961c-.22439.08725-.41436.24503-.54131.4496-.12696.20456-.18402.44483-.16261.68463.02142.2398.12016.46617.28135.64497s.37611.3005.61241.3466l4.10234.8054v4.5743c-.00081.2491.07324.4928.21253.6994.1393.2065.33743.3665.56872.4592.23093.0943.48489.1169.72886.0649.24397-.0519.46666-.1761.63911-.3563l1.97808-2.0516 3.1383 2.7469c.2264.2008.5185.3119.8211.3125.1326-.0001.2644-.021.3906-.0618.2063-.0654.3917-.1837.538-.3431.1462-.1594.2482-.3544.2956-.5654l3.1711-13.79536c.0284-.12442.0224-.2542-.0174-.37545s-.1118-.22939-.2083-.31283zm-4.7766 2.8125-6.99923 5.01254-3.875-.7602zm-6.2297 10.76644v-3.7094l1.93672 1.6984zm6.8383.625-6.45939-5.6641 9.29689-6.66328z",
    fill: "#242323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.baff61f6cd9a0b414a565e18109825fd.svg";
export { ForwardRef as ReactComponent };